export default class Attendees {
  constructor() {
    this.attendees = [];
    this.form = null;
    this.validation = {};
    this.addons = {
      total_session_addons: 0,
      total_item_addons: 0
    };
    this.fields_with_coupons = [];
  }
}
